module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-drawer', {
    attrs: {
      "title": "礼品卡详情",
      "visible": _vm.drawerVisible,
      "direction": _vm.direction,
      "size": _vm.size,
      "before-close": _vm.handleClose,
      "custom-class": "c-drawer"
    },
    on: {
      "update:visible": function($event) {
        _vm.drawerVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('el-form', {
    ref: "formRef",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "model": _vm.giftCardInfo,
      "label-position": 'right',
      "size": "small",
      "label-width": "120px",
      "disabled": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "卡号"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.giftCardInfo.cardNo),
      callback: function($$v) {
        _vm.$set(_vm.giftCardInfo, "cardNo", $$v)
      },
      expression: "giftCardInfo.cardNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "卡片名称"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.giftCardInfo.cardName),
      callback: function($$v) {
        _vm.$set(_vm.giftCardInfo, "cardName", $$v)
      },
      expression: "giftCardInfo.cardName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "卡片类型"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.giftCardInfo.cardTypeName),
      callback: function($$v) {
        _vm.$set(_vm.giftCardInfo, "cardTypeName", $$v)
      },
      expression: "giftCardInfo.cardTypeName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "会员信息"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.subscriberInfo),
      callback: function($$v) {
        _vm.subscriberInfo = $$v
      },
      expression: "subscriberInfo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "购买时间"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.giftCardInfo.buyTime),
      callback: function($$v) {
        _vm.$set(_vm.giftCardInfo, "buyTime", $$v)
      },
      expression: "giftCardInfo.buyTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "购买金额"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.giftCardInfo.buyAmount),
      callback: function($$v) {
        _vm.$set(_vm.giftCardInfo, "buyAmount", $$v)
      },
      expression: "giftCardInfo.buyAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "卡片面值"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.giftCardInfo.amount),
      callback: function($$v) {
        _vm.$set(_vm.giftCardInfo, "amount", $$v)
      },
      expression: "giftCardInfo.amount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "余额"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.giftCardInfo.balance),
      callback: function($$v) {
        _vm.$set(_vm.giftCardInfo, "balance", $$v)
      },
      expression: "giftCardInfo.balance"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "激活时间"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.giftCardInfo.activeTime),
      callback: function($$v) {
        _vm.$set(_vm.giftCardInfo, "activeTime", $$v)
      },
      expression: "giftCardInfo.activeTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "过期时间"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.giftCardInfo.expiredTime),
      callback: function($$v) {
        _vm.$set(_vm.giftCardInfo, "expiredTime", $$v)
      },
      expression: "giftCardInfo.expiredTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.giftCardInfo.statusName),
      callback: function($$v) {
        _vm.$set(_vm.giftCardInfo, "statusName", $$v)
      },
      expression: "giftCardInfo.statusName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "clearable": ""
    },
    model: {
      value: (_vm.giftCardInfo.remark),
      callback: function($$v) {
        _vm.$set(_vm.giftCardInfo, "remark", $$v)
      },
      expression: "giftCardInfo.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "editOpera-seat"
  }), _vm._v(" "), _c('div', {
    staticClass: "drawer-footer"
  }, [_c('div', {
    staticClass: "operation"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取消")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-2a8b89e1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/giftCard/components/infoRecord.vue
// module id = 1610
// module chunks = 0